import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=21768343&scoped=true&"
import script from "./profile.vue?vue&type=script&lang=js&"
export * from "./profile.vue?vue&type=script&lang=js&"
import style0 from "./profile.vue?vue&type=style&index=0&id=21768343&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21768343",
  null
  
)

export default component.exports